import CalendarIcon from '@/assets/icons/calendar.svg?react';

export const DatePickerOpenIcon = () => <CalendarIcon />;
